export const REGEX_IS_PROJECT = /^\/realestates\/project(?:\/.*)?$/;
export const REGEX_PROPERTY_DRAFT =
  /^\/realestates\/borrador\/(\d+)\/editar(?:\/.*)?$/;
export const REGEX_PROJECT_DRAFT =
  /^\/realestates\/project\/borrador\/(\d+)\/editar(?:\/.*)?$/;
export const REGEX_PROPERTY_EDIT = /^\/realestates\/editar\/(\d+)(?:\/.*)?$/;
export const REGEX_PROJECT_EDIT = /^\/realestates\/project\/editar\/(\d+)(?:\/.*)?$/;
export const REGEX_DRAFT =
  /^\/realestates\/(?:project\/)?borrador\/\d+\/editar(?:\/.*)?$/;
export const REGEX_FORM_EDIT = /^\/realestates\/(?:project\/)?editar\/\d+(?:\/.*)?$/;

export const feedBackFormProperty = (pathname: string) => {
  const isPropertyDraft = REGEX_PROPERTY_DRAFT.test(pathname);
  const isProjectDraft = REGEX_PROJECT_DRAFT.test(pathname);
  const isPropertyFormEdit = REGEX_PROPERTY_EDIT.test(pathname);
  const isProjectFormEdit = REGEX_PROJECT_EDIT.test(pathname);

  const isDraft = isPropertyDraft || isProjectDraft;
  const isFormEdit = isPropertyFormEdit || isProjectFormEdit;
  const isProject =
    isProjectDraft || isProjectFormEdit || REGEX_IS_PROJECT.test(pathname);

  return {
    isDraft,
    isFormEdit,
    isProject,
    isCreatingDraft: isDraft,
    isCreatingPropertyDraft: isPropertyDraft,
    isCreatingPropertyFormEdit: isPropertyFormEdit,
    isCreatingProjectDraft: isProjectDraft,
    isCreatingProjectFormEdit: isProjectFormEdit,
    isPropertyDraft,
    isProjectDraft,
    isPropertyFormEdit,
    isProjectFormEdit
  };
};
